/**
 * Vue 应用入口
 *
 * 模块说明：
 * - 内部员工系统：使用 ShareWin-Token 认证，走 /login 登录
 * - 客户门户系统：使用 CUSTOMER_PORTAL_TOKEN 认证，走 /c/login 登录
 * - 两套系统在 main.js 入口处完全隔离，互不影响
 *
 * @author LWX
 * @date 2026-03-23
 */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './directives/permission'
import drag from '@/directives/drag'
import axios from 'axios'
import '@/assets/css/global.css'

Vue.directive('drag', drag)

Vue.config.productionTip = false
Vue.use(ElementUI)

// ========== 添加axios拦截器，打印请求和响应 ==========
// 请求拦截器
axios.interceptors.request.use(config => {
  return config
})

// 响应拦截器
axios.interceptors.response.use(
    response => {
      return response
    },
    error => {
      return Promise.reject(error)
    }
)
// ========== 拦截器添加结束 ==========

Vue.mixin({
  computed: {
    pageTitle() {
      const menus = this.$store.state.user?.menus || []
      const currentPath = this.$route.path
      const findMenuName = (list, path) => {
        for (let item of list) {
          if (item.path === path) return item.name
          if (item.children) {
            const found = findMenuName(item.children, path)
            if (found) return found
          }
        }
        return null
      }
      return findMenuName(menus, currentPath) || '项目管理'
    }
  }
})

function isTokenValid() {
  const token = localStorage.getItem('ShareWin-Token') || store.getters.token
  if (!token) return false
  return true
}

async function initApp() {
  // ================================================================
  // 1. 优先判断：客户门户 Token
  //    客户登录时使用 CUSTOMER_PORTAL_TOKEN，完全独立于内部员工
  // ================================================================
  const portalToken = localStorage.getItem('CUSTOMER_PORTAL_TOKEN')
  if (portalToken) {
    // 客户门户模式：不执行内部员工逻辑，直接启动应用
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    return
  }

  // ================================================================
  // 2. 内部员工 Token（原有逻辑）
  // ================================================================
  const token = localStorage.getItem('ShareWin-Token') || store.getters.token

  if (token && isTokenValid()) {
    try {
      await store.dispatch('user/getUserInfo')
    } catch (error) {
      console.error('获取用户信息失败:', error)
      localStorage.removeItem('ShareWin-Token')
      localStorage.removeItem('ShareWin-Token-Time')
      localStorage.removeItem('ShareWin-User')
      store.dispatch('user/logout')
      if (window.location.pathname !== '/login') {
        router.push('/login')
      }
    }
  }

  // ================================================================
  // 3. 启动 Vue 应用
  // ================================================================
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

Vue.directive('show-start', {
  inserted(el) {
    const input = el.querySelector('.el-input__inner')
    if (input) {
      input.style.direction = 'ltr'
      input.style.textAlign = 'left'
      input.style.unicodeBidi = 'bidi-override'
    }
  }
})

initApp()